<template>
  <div class="clients">
    <div :style="'backgroundImage: url('+clients_bg+')'" class="clients_bg"></div>
    <ClientsHeader/>
    <router-view />
    <ClientsFooter/>
  </div>
</template>

<script>
/* eslint-disable no-undef */
// import functionJs from '@/assets/js/function_index.js'
import ClientsHeader from './components/ClientsHeader'
import ClientsFooter from './components/ClientsFooter'
import bg from '@/assets/images/clients/bg_default.png'

export default {
  name: 'async',
  components: {
    ClientsHeader,
    ClientsFooter
  },
  data () {
    return {
      clients_bg: bg
    }
  }
}
</script>

<style lang="scss"  scoped>
.clients {
  margin-top: 0;
}
.clients_bg {
  z-index: -1;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 50%;
  min-height: 100%;
  width: 100%;
  max-width: 600px;
  transform: translate(-50%, 0);
}
@media screen and (min-width: 576px) {
  .clients_bg {
    max-width: 900px;
  }
}
@media screen and (min-width: 768px) {
  .clients {
    margin-top: -128px;
  }
  .clients_bg {
    max-width: 1500px;
  }
}
@media screen and (min-width: 1280px) {
  .clients_bg {
    max-width: 1500px;
  }
}
@media screen and (min-width: 1680px) {
  .clients_bg {
    max-width: 1700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/clients/index.vue